export default {
    "template": "componentsCompany/global/CompanySettings",
    "default_number_format": {
        "decimal_point": ",",
        "decimal_length": 2
    },
    "menu_template": "componentsCompany/global/header/MenuComponent"
}